import { useEffect, useState } from 'react'

/** Debounce simples: só propaga `value` após `delay` ms sem novas mudanças.
 *  Usado nos filtros de texto livre (Painel de Descarga, Transporte Máquina). */
export function useDebounced<T>(value: T, delay = 300): T {
  const [v, setV] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setV(value), delay)
    return () => clearTimeout(t)
  }, [value, delay])
  return v
}
